// extracted by mini-css-extract-plugin
export default {"label":"SettingsPage_label__Myj0J","field":"SettingsPage_field__m24fC"};